export default __webpack_public_path__ + "static/media/groupchat.59d13211.svg";